import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { ToastContainer } from 'react-toastify'
import { renderToastWarn } from 'utils/ToastUtils'

import ContentHeader from 'component/utils/ContentHeader'
import Grid from 'component/utils/Grid'

import Button from 'component/Button/index'
import Glyph from 'component/utils/Glyph'
import FilterIconSVG from 'component/svgComponents/filter'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import SideFilterForm from 'component/sectionBlock/SideFilterForm'
import SectionBlockFormModal from 'component/sectionBlock/SectionBlockFormModal'

import * as sectionBlockActions from 'action/sectionBlock'
import ExclusionModal from 'component/Modal/ExclusionModal'
import ConfirmationModal from 'component/ConfirmationModal/ConfirmationModal'

import Col from 'component/utils/Col'
import Pagination from 'component/pagination/Pagination'
import ArrowDownSVG from 'component/svgComponents/arrowDownGrey'

const DEFAULT_PARAMS = {
  level: 2,
  sectionId: 0,
  subSectionId: 0,
  typeId: 0,
  subTypeId: 0,
  limit: 50,
  offset: 0,
}

const DEFAULT_FILTER_INITIAL_VALUES = {
  store: null,
  section: null,
  subsection: null,
  type: null,
  subtype: null,
}

class SectionBlockContainer extends PureComponent {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    clearSuccessMessage: PropTypes.func.isRequired,
    deleteSectionBlock: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    error: PropTypes.object,
    list: PropTypes.array.isRequired,
    listSectionBlock: PropTypes.func.isRequired,
    listStores: PropTypes.func.isRequired,
    saveSectionBlock: PropTypes.func.isRequired,
    storeList: PropTypes.array.isRequired,
    success: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
    idBranchList: PropTypes.object,
    permissions: PropTypes.array.isRequired,
  }

  constructor() {
    super()

    this.state = {
      2: [],
      3: [],
      4: [],
      5: [],
      loadingNames: false,
      sectionBlockModal: false,
      sectionBlock: {},
      idBranchList: [],
      sideFilterVisible: false,
      filters: DEFAULT_FILTER_INITIAL_VALUES,
      showExclusionSuccess: false,
      showCreationSuccess: false,
      page: 1,
      orderBy: '',
    }
  }

  componentDidMount() {
    const {
      auth: {
        user: { dsToken },
      },
      listStores,
      listSectionBlock,
    } = this.props
    const { page, orderBy } = this.state

    listStores(dsToken)
    listSectionBlock(dsToken, {}, page, orderBy)
  }

  async componentDidUpdate(prevProps) {
    const { clearSuccessMessage, error, success } = this.props

    if (success !== prevProps.success && success) {
      clearSuccessMessage()
    }

    if (error !== prevProps.error && error) {
      renderToastWarn(error)
    }
    await this.getSections(prevProps)
  }

  toggleSideFilter = () => {
    this.setState({
      sideFilterVisible: false,
    })
  }

  renderSideFilterForm = () => {
    const { storeList } = this.props
    const {
      sideFilterVisible,
      filters,
      2: sections,
      3: subsections,
      4: types,
      5: subtypes,
    } = this.state

    const handleSubmitSideFilterForm = (values) => {
      this.setState(
        {
          sideFilterVisible: false,
          filters: { ...values },
          page: 1,
        },
        this.findFilters
      )
    }

    return (
      <SideFilterForm
        shown={sideFilterVisible}
        initialValues={filters}
        setSideFilterVisible={this.toggleSideFilter}
        submit={handleSubmitSideFilterForm}
        translate={translate}
        options={{
          sections,
          subsections,
          types,
          subtypes,
          stores: storeList,
        }}
      />
    )
  }

  findFilters = () => {
    const {
      auth: {
        user: { dsToken },
      },
      listSectionBlock,
    } = this.props
    const { filters, page, orderBy } = this.state
    const { stores } = filters

    listSectionBlock(
      dsToken,
      {
        idBranchList: (stores || []).map((s) => String(s).padStart(4, '0')),
        sectionList: filters.sections,
        subSectionList: filters.subsections,
        typeList: filters.types,
        subTypeList: filters.subtypes,
      },
      page,
      orderBy
    )
  }

  handleSubmit = async (stores, values) => {
    const {
      saveSectionBlock,
      auth: { user },
    } = this.props
    await saveSectionBlock(user.dsToken, {
      treeList: [...values],
      idBranchList: [...stores],
    })
    this.setState({ showCreationSuccess: true }, this.findFilters)
  }

  callApi = async (token, params) => {
    const { data } = await new Api(token, () => { }).post(
      API_URL.SECTIONS_HIERARCHY,
      params
    )

    return data
  }

  getSections = async (prevProps = null) => {
    const {
      list,
      auth: {
        user: { dsToken: token },
      },
    } = this.props

    if (
      list &&
      Array.isArray(list) &&
      list.length > 0 &&
      prevProps &&
      prevProps.list !== list
    ) {
      this.setState({ loadingNames: true })

      let sections = {}
      await Promise.all(
        (list || []).map(async (item) => {
          let level
          if (item.subTypeId) {
            level = 5
          } else if (item.typeId) {
            level = 4
          } else if (item.subSectionId) {
            level = 3
          } else {
            level = 2
          }

          for (let i = level; i > 1; i -= 1) {
            const params = {
              ...DEFAULT_PARAMS,
              sectionId: item.sectionId,
              subSectionId: i > 2 ? item.subSectionId : 0,
              typeId: i > 3 ? item.typeId : 0,
              subTypeId: i > 4 ? item.subTypeId : 0,
              level: i,
            }
            const data = await this.callApi(token, params)

            if (sections[i]) {
              sections = { ...sections, [i]: [...sections[i], data[0]] }
            } else {
              sections = { ...sections, [i]: [data[0]] }
            }
          }
        })
      )

      this.setState({ ...sections, loadingNames: false })
    }
  }

  toggleRemove = async (item) => {
    const {
      auth: {
        user: { dsToken },
      },
      deleteSectionBlock,
    } = this.props
    await deleteSectionBlock(
      dsToken,
      { idBranchList: [item.idBranch], idSectionBlock: item.idSectionBlock }
    )
    const { list } = this.props
    let { page } = this.state

    if ((list.resultList || []).length <= 1) {
      page = 1
    }
    this.setState({ showExclusionSuccess: true, page }, this.findFilters)
  }

  toggleOrder = (field) => {
    let newOrder = 'ASC'
    const { orderBy } = this.state

    if (orderBy) {
      const [currentField, order] = orderBy.split(' ')

      if (currentField === field) {
        if (order === 'ASC') {
          newOrder = 'DESC'
        }
      }
    }

    this.setState(
      {
        orderBy: `${field} ${newOrder}`,
      },
      this.findFilters
    )
  }

  getOrderArrowClasses = (field) => {
    const { orderBy } = this.state

    if (orderBy) {
      const [currentField, order] = orderBy.split(' ')

      if (currentField === field) {
        if (order === 'DESC') {
          return 'order-arrow-active order-arrow-revert'
        }
        return 'order-arrow-active'
      }
    }
    return ''
  }

  render() {
    const { list, translate, storeList } = this.props

    const {
      2: sections,
      3: subsections,
      4: types,
      5: subtypes,
      showExclusionSuccess,
      showCreationSuccess,
    } = this.state

    const pagination = list.pages || {}

    return (
      <Fragment>
        <div className='new-style'>
          <ContentHeader>
            {translate('mobile.punctual.adjust.sectionBlock')}
          </ContentHeader>

          <div className='new-style-filter'>
            <section className='container-fluid new-upper-container'>
              <div className='col-xs-12 col-md-12'>
                <div className='float-right margin-top'>
                  <SectionBlockFormModal
                    translate={translate}
                    handleSubmit={this.handleSubmit} // Função que vai ser executada quando form for submitado, vai ter que chamar action/api pra salvar/editar um novo block
                    options={{
                      sections,
                      subsections,
                      types,
                      subtypes,
                      stores: storeList,
                    }}
                  />
                  <Button
                    className='btn btn-secondary'
                    text={translate('mobile.filter')}
                    onClick={() =>
                      this.setState({
                        sideFilterVisible: true,
                      })
                    }
                    svgIcon
                    svgComponent={<FilterIconSVG newDesign={false} className="margin-svg-filter" />}

                  />
                </div>
              </div>
              {!!showCreationSuccess && (
                <ConfirmationModal
                  t={translate}
                  message={translate(
                    'new.home.quickAccess.add.descriptionModal'
                  )}
                  title={translate('success')}
                  onConfirm={() =>
                    this.setState({ showCreationSuccess: false })
                  }
                />
              )}
            </section>
          </div>
          <div className='new-style-table'>
            <Grid fluid className='no-padding'>
              <div className='outer-table new-outer-table'>
                <div>
                  <table cellPadding={0} cellSpacing={0} className='new-table'>
                    <thead>
                      <tr>
                        <th onClick={() => this.toggleOrder('idBranch')}>
                          {translate('rotativeInventory.dsBranch')}&nbsp;&nbsp;
                          <ArrowDownSVG
                            className={`order-arrow ${this.getOrderArrowClasses(
                              'idBranch'
                            )}`}

                          />
                        </th>
                        <th onClick={() => this.toggleOrder('sectionId')}>
                          {translate(
                            'mobile.punctual.adjust.sectionBlock.section'
                          )}
                          &nbsp;&nbsp;
                          <ArrowDownSVG
                            className={`order-arrow ${this.getOrderArrowClasses(
                              'sectionId'
                            )}`}

                          />
                        </th>
                        <th>
                          {translate(
                            'mobile.punctual.adjust.sectionBlock.subSection'
                          )}
                        </th>
                        <th>
                          {translate(
                            'mobile.punctual.adjust.sectionBlock.type'
                          )}
                        </th>
                        <th>
                          {translate(
                            'mobile.punctual.adjust.sectionBlock.subType'
                          )}
                        </th>
                        <th style={{ textAlign: 'center' }}>
                          {translate(
                            'mobile.punctual.adjust.sectionBlock.delete'
                          )}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(list.resultList || []).map((data, idx) => {
                        const storeObject =
                          storeList.find(
                            (storeItem) => +storeItem.id === +data.idBranch
                          ) || {}
                        return (
                          <tr key={`section-block-table-row-${idx}`}>
                            <td>{`${storeObject.id} - ${storeObject.name}`}</td>
                            <td>
                              {data.sectionId
                                ? `${data.sectionId} - ${data.sectionNm}`
                                : '-'}
                            </td>
                            <td>
                              {data.subSectionId
                                ? `${data.subSectionId} - ${data.subSectionNm}`
                                : '-'}
                            </td>
                            <td>
                              {data.typeId
                                ? `${data.typeId} - ${data.typeNm}`
                                : '-'}
                            </td>
                            <td>
                              {data.subTypeId
                                ? `${data.subTypeId} - ${data.subTypeNm}`
                                : '-'}
                            </td>
                            <td
                              style={{ textAlign: 'center', fontSize: '20px' }}
                            >
                              <ExclusionModal
                                t={translate}
                                title={translate(
                                  'newSectionBlock.remove.title'
                                )}
                                message={() => (
                                  <div>
                                    <p>
                                      {translate(
                                        'newSectionBlock.remove.description'
                                      )}
                                    </p>
                                    <p>
                                      {translate('rotativeInventory.dsBranch')}:{' '}
                                      <b>{`${storeObject.id} - ${storeObject.name}`}</b>
                                      <br />
                                      {translate(
                                        'mobile.punctual.adjust.sectionBlock.section'
                                      )}
                                      :{' '}
                                      <b>
                                        {data.sectionId
                                          ? `${data.sectionId} - ${data.sectionNm}`
                                          : '-'}
                                      </b>
                                      <br />
                                      {translate(
                                        'mobile.punctual.adjust.sectionBlock.subSection'
                                      )}
                                      :{' '}
                                      <b>
                                        {data.subSectionId
                                          ? `${data.subSectionId} - ${data.subSectionNm}`
                                          : '-'}
                                      </b>
                                      <br />
                                      {translate(
                                        'mobile.punctual.adjust.sectionBlock.type'
                                      )}
                                      :{' '}
                                      <b>
                                        {data.typeId
                                          ? `${data.typeId} - ${data.typeNm}`
                                          : '-'}
                                      </b>
                                      <br />
                                      {translate(
                                        'mobile.punctual.adjust.sectionBlock.subType'
                                      )}
                                      :{' '}
                                      <b>
                                        {data.subTypeId
                                          ? `${data.subTypeId} - ${data.subTypeNm}`
                                          : '-'}
                                      </b>
                                      <br />
                                    </p>
                                  </div>
                                )}
                                onConfirm={() => this.toggleRemove(data)}
                                renderButton={({ onClick }) => (
                                  <Glyph
                                    type='trash-can'
                                    color='danger'
                                    onClick={(e) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      onClick && onClick()
                                    }}
                                  />
                                )}
                              />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
                {!!showExclusionSuccess && (
                  <ConfirmationModal
                    t={translate}
                    message={translate(
                      'new.home.quickAccess.remove.descriptionModal'
                    )}
                    title={translate('success')}
                    onConfirm={() =>
                      this.setState({ showExclusionSuccess: false })
                    }
                  />
                )}
              </div>
            </Grid>
            <Col className='align-center margin-bottom'>
              {!!(list.resultList || []).length &&
                (pagination.pageCount || 0) > 1 && (
                  <Pagination
                    count={pagination.size}
                    current={pagination.page}
                    getPage={(page) =>
                      this.setState({ page }, this.findFilters)
                    }
                    pages={pagination.pageCount}
                  />
                )}
            </Col>
          </div>
          {this.renderSideFilterForm()}
        </div>
        <ToastContainer newestOnTop />
      </Fragment>
    )
  }
}

/* istanbul ignore next */
const mapStateToProps = (rootReducer) => ({
  ...(rootReducer || {}).sectionBlockReducer,
  permissions: rootReducer.menuReducer.permissions,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...sectionBlockActions }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    SectionBlockContainer
  )
)

export { SectionBlockContainer }
